import Axios, { AxiosRequestConfig } from 'axios'

import { toast } from 'react-toastify'
import { API_URL } from '../config'
import storage from '../utils/storage'

let headers = {}
if (process.env.NODE_ENV === 'development')
  headers = { ...headers, 'ngrok-skip-browser-warning': 'any' }

function authRequestInterceptor(config: AxiosRequestConfig) {
  const token = storage.getToken()
  if (token && config?.headers) {
    config.headers.authorization = `Bearer ${token}`
  }
  if (config.url) {
    config.url = config.url.replace(/%20/g, '').replace(/ /g, '')
  }
  return config
}

export const axios = Axios.create({
  baseURL: API_URL,
  headers
})

axios.interceptors.request.use(authRequestInterceptor)
axios.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const message = error.response?.data?.message || error.message

    if (message === 'Network Error')
      toast.error('Verifique a conexão com o servidor!', {
        toastId: 'networkError'
      })

    if (error?.response?.status === 401) {
      // Só mostra o erro se houver token no storage (não foi um logout intencional)
      const token = storage.getToken()
      if (token) {
        toast.error('Acesso Negado! Verifique seu usuário e/ou senha!', {
          toastId: 'Unauthorized'
        })
      }
    }
    return Promise.reject(error)
  }
)
